import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Typography from '../../../UniformComponents/Typography'
import CrossbreakChartSlot from './components/CrossbreakChartSlot'

const CrossbreakLayout = observer(({ store }) => (
    <div className="pp-slide-layout-container">
        <div className="pp-slide-commentary-container">
            <Typography type="tiny" color="grey">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
        </div>

        <br />

        <div className="pp-chart-slots">
            <CrossbreakChartSlot
                store={store}
                key={`${store.activeSlide.id}-${0}`}
                position={0}
            />
        </div>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
            <Typography type="tiny">{store.activeSlide.question.has(0) ? store.activeSlide.question.get(0).questionLongText :  i18n.t('question')}</Typography>

            <Typography type="tiny">{i18n.t('powerpoint.slide.base-size-brackets')}</Typography>
        </div>
    </div>
))

export default CrossbreakLayout
